import React from 'react';
import { snakeCase } from 'lodash';
import classNames from 'classnames';

import ToolTip from 'shared-components/ToolTip/ToolTip';
import { btnLocationEnum } from 'utils/segment';

import styles from './QuantityButton.module.css';
import { ReactComponent as ReloadIcon } from './reloadIcon.svg';
import { ReactComponent as DisabledIcon } from './Disabled.svg';
import { ReactComponent as MinusIcon } from './Minus.svg';
import { ReactComponent as PlusIcon } from './Plus.svg';

const QuantityButton = (props) => {
  const {
    areCartOperationsDisabled,
    onAdd,
    onRemove,
    quantity,
    max,
    inventoryLimit,
    isPreviouslyPurchased,
    quantityUpdating,
    viewSize,
    buttonLocation,
    isSponsored,
    soldOut,
    variantId,
    version,
    isGwp,
  } = props;
  const isMaxed = quantity >= max;
  const isOverInventoryLimit = quantity >= inventoryLimit;
  const selectUserProductMaxTxt = `You have previously purchased this item and can only buy ${max} more.`;
  const isShoppingCart = buttonLocation === btnLocationEnum.cart;
  const isAccordion =
    buttonLocation === btnLocationEnum.productAccordion ||
    buttonLocation === btnLocationEnum.recommendedAccordion;
  const isCard = buttonLocation === btnLocationEnum.productCard;

  const handleClickAdd = () => {
    if (isMaxed || soldOut || isOverInventoryLimit) {
      return;
    }
    onAdd('+');
  };
  const handleClickRemove = () => onRemove('-');

  return (
    <div
      className={classNames(
        styles.quantityBtnContainer,
        styles.redesign,
        styles[version],
        styles[viewSize],
        {
          [styles.cartStyle]: isShoppingCart,
          [styles.sponsoredStyle]: isSponsored && isCard,
          [styles.accordionStyle]: isAccordion,
          [styles.gwpQuantityButton]: isGwp && !isShoppingCart,
        }
      )}
    >
      <button
        id={`${variantId}_remove_${snakeCase(buttonLocation)}`}
        className={styles.removeButton}
        onClick={handleClickRemove}
        disabled={areCartOperationsDisabled}
        type="button"
        data-dd-action-name={`Decrement quantity button in ${buttonLocation}`}
      >
        <RemoveIcon version={version} />
      </button>

      <div
        className={classNames(styles.quantityText, {
          [styles.cartStyles]: isShoppingCart,
          [styles.accordionStyle]: isAccordion,
        })}
      >
        {quantityUpdating ? (
          <ReloadIcon />
        ) : (
          `${quantity} ${isMaxed ? 'MAX' : ''}`
        )}
      </div>

      <ToolTip
        content={selectUserProductMaxTxt}
        enabled={!isShoppingCart && isMaxed && isPreviouslyPurchased}
        viewSize={viewSize}
        isAccordion={isAccordion}
      >
        <button
          type="button"
          id={`${variantId}_add_${snakeCase(buttonLocation)}`}
          onClick={handleClickAdd}
          disabled={
            areCartOperationsDisabled ||
            isMaxed ||
            soldOut ||
            isOverInventoryLimit
          }
          className={styles.addButton}
          data-testid="add-product-btn"
          data-dd-action-name={`Increment quantity button in ${buttonLocation}`}
        >
          <AddIcon isMaxed={isMaxed} soldOut={soldOut} version={version} />
        </button>
      </ToolTip>
    </div>
  );
};

const AddIcon = ({ isMaxed, soldOut, version }) => {
  if (version === 'boost') {
    return isMaxed || soldOut ? <DisabledIcon /> : <PlusIcon />;
  }
  return <i className="fal fa-plus" />;
};

const RemoveIcon = ({ version }) => {
  if (version === 'boost') return <MinusIcon />;
  return <i className="fal fa-minus" />;
};

export default QuantityButton;
